import { render, staticRenderFns } from "./TranslationAccountManager.vue?vue&type=template&id=0050490a&scoped=true&"
import script from "./TranslationAccountManager.vue?vue&type=script&lang=js&"
export * from "./TranslationAccountManager.vue?vue&type=script&lang=js&"
import style0 from "./TranslationAccountManager.vue?vue&type=style&index=0&id=0050490a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050490a",
  null
  
)

export default component.exports